import React from 'react'
import { WorkPeriodTag } from '../../api/work-period-tags'
import { useCreateMutation, useUpdateMutation } from '../../queries/work-period-tags'
import { Field, Form, Formik } from 'formik'
import InputField from '../form/fields/input'
import { RequestButton, RequestMessage } from '../request-components/request-components'

export interface WorkPeriodTagFormProps {
  tag?: WorkPeriodTag
  onSuccess?: () => void
}

/**
 * Form component for creating or editing work period tags
 * Includes a name field and isInactive checkbox
 */
const WorkPeriodTagForm: React.FC<WorkPeriodTagFormProps> = ({ tag, onSuccess }) => {
  const createMutation = useCreateMutation()
  const updateMutation = useUpdateMutation()

  const handleSuccess = () => {
    if (onSuccess) {
      onSuccess()
    }
  }

  return (
    <Formik
      initialValues={tag || { name: '', isInactive: false }}
      enableReinitialize
      validate={values => {
        const errors: any = {}
        if (!values.name) errors.name = 'Champ requis'
        return errors
      }}
      onSubmit={async values => {
        if (tag) {
          await updateMutation.mutateAsync({ ...values, id: tag._id })
        } else {
          await createMutation.mutateAsync({ ...values })
        }
        handleSuccess()
      }}
    >
      {() => {
        return (
          <Form autoComplete="off">
            <Field
              label="Nom"
              name="name"
              component={InputField}
              placeholder="Ex: Journée normale, Journée de repos, Congé..."
            />
            <RequestButton
              color="primary"
              type="submit"
              mutation={tag ? updateMutation : createMutation}
              data-test="submit-work-period-tag-form"
            >
              {tag ? 'Mettre à jour la catégorie' : 'Créer la catégorie'}
            </RequestButton>
            <RequestMessage mutation={tag ? updateMutation : createMutation} />
          </Form>
        )
      }}
    </Formik>
  )
}

export default WorkPeriodTagForm
